import React, { useContext, useState } from "react";
import DeviceFilters from "../DeviceFilters/DeviceFilters";
import Pagination from "../../Shared/Pagination/Pagination";
import GatewayShimmer from "./GatewayShimmer/GatewayShimmer";
import GatewayCardGrid from "./GatewayCardGrid/GatewayCardGrid";
import AddGatewayModal from "./AddGatewayModal/AddGatewayModal";
import { Container, Footer } from "./Gateways.styles";
import { useCompanyAsAdminQuery } from "../../../graphql";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import { NoGatewaysMessage } from "../../Gateway/PrinterGatewaysHelper";
import GatewayPrinterCard from "../../Gateway/GatewayPrinterCard";
import useGatewayManager from "./GatewayOperations/useGatewayManager";
import useGatewayList from "./GatewayOperations/useGatewayList";
import CSEGatewaySerialSearch from "./CSEGatewaySerialSearch/CSEGatewaySerialSearch";

const Gateways: React.FC = () => {
    const { t } = useContext(ApplicationContext);
    const { company } = useCompanyAsAdminQuery();

    const {
        loading,
        gateways,
        companiesListItem,
        activePrinterSerial,
        deviceFound,
        hasGateway,
        hasOrphanedDevice,
        isCSE,
        isCSEOrReseller,
        searchGateways,
        refreshGateways,
    } = useGatewayManager();

    const {
        validPage,
        rowsPerPage,
        totalPages,
        searchTerm,
        filteredGateways,
        visibleGateways,
        visibleRangeStart,
        visibleRangeEnd,
        newThingName,
        setPage,
        setNewThingName,
        updateSearchTerm,
        updateRowsPerPage,
        removeGateway,
    } = useGatewayList({ gateways });

    const [isAddGatewayOpen, setIsAddGatewayOpen] = useState(false);
    const [checkIfPollingTrue, setCheckIfPollingTrue] = useState(false);
    console.log("checkIfPollingTrue", checkIfPollingTrue);

    const isSerialSearch = isCSEOrReseller && Boolean(activePrinterSerial);

    const showGatewayGrid =
        !isCSEOrReseller || (isSerialSearch && deviceFound && (hasGateway || hasOrphanedDevice));

    const showCompanyInfo = isSerialSearch && deviceFound && !hasGateway && !hasOrphanedDevice;

    const handleGatewayRemoved = (coreDeviceThingName: string): void => {
        removeGateway(coreDeviceThingName);
        void refreshGateways();
    };

    const handleSuccessfulRequest = async (): Promise<void> => {
        setIsAddGatewayOpen(false);
        setPage(1);

        await refreshGateways();
    };

    return (
        <Container>
            {isCSEOrReseller && <CSEGatewaySerialSearch isCSE={isCSE} onSearch={searchGateways} />}

            {isSerialSearch && !deviceFound && !loading && <NoGatewaysMessage />}

            {showGatewayGrid && (
                <>
                    <DeviceFilters
                        value={searchTerm}
                        placeholder={t("gateways.search_by_site")}
                        onChange={updateSearchTerm}
                    />

                    {loading ? (
                        <GatewayShimmer />
                    ) : (
                        <>
                            <GatewayCardGrid
                                gateways={visibleGateways}
                                page={validPage}
                                setCheckIfPollingTrue={setCheckIfPollingTrue}
                                setNewThingName={setNewThingName}
                                newThingName={newThingName}
                                onSuccessfullRequest={handleSuccessfulRequest}
                                onGatewayRemoved={handleGatewayRemoved}
                                printerSerial={activePrinterSerial}
                                cloudAccessType={company?.cloudAccessType}
                            />

                            {filteredGateways.length > 5 && (
                                <Footer>
                                    <Pagination
                                        currentPage={validPage}
                                        totalPages={totalPages}
                                        totalItems={filteredGateways.length}
                                        rowsPerPage={rowsPerPage}
                                        startItem={visibleRangeStart}
                                        endItem={visibleRangeEnd}
                                        itemLabel="Gateways"
                                        onPageChange={setPage}
                                        onRowsChange={updateRowsPerPage}
                                    />
                                </Footer>
                            )}
                        </>
                    )}
                </>
            )}

            {showCompanyInfo && !loading && (
                <GatewayPrinterCard
                    companiesListItem={companiesListItem}
                    printerState={{
                        printerSerial: activePrinterSerial!,
                        printerGateway: "none",
                    }}
                />
            )}

            <AddGatewayModal
                open={isAddGatewayOpen}
                onClose={() => setIsAddGatewayOpen(false)}
                onSuccessfullRequest={handleSuccessfulRequest}
                setCheckIfPollingTrue={setCheckIfPollingTrue}
                setNewThingName={setNewThingName}
                printerSerial={activePrinterSerial}
                cloudAccessType={company?.cloudAccessType}
            />
        </Container>
    );
};

export default Gateways;
